import React from 'react';
import { Table, Button, Input, Card, Modal, message, Col, DatePicker, Select, Popover, TreeSelect} from 'antd';
import common from '../../assets/common.js';
import moment from 'moment';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';
const Option = Select.Option;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { RangePicker } = DatePicker;
const defaultDate = [moment().startOf('day'),moment().endOf('day')];
class MemberTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      batchList : [],
      search : "",
      modalType : "",
      modalData : "",
      visible: false,
      pwdUrl:"",
      passWDInfo: "",
      key: "",
      openTime: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      cardType: 0,
      value: "",
      example:[],
      types:{1:"身份证",2:"Mifare_UltraLight",3:"Mifare_One(S50)",4:"Mifare_One(S70)",5:"Mifare_Pro(X)",6:"Mifare_DESFire",238:"其他"}
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
    // console.log(window.localStorage.getItem("userName"));
    if(window.localStorage.getItem("userName")) {
      let userName = window.localStorage.getItem("userName");
      let cardNo = window.localStorage.getItem("cardNo");
      this_.setState({
        userName,cardNo
      },() => {
          this_.getList();
          setTimeout(()=> {
            window.localStorage.clear("userName");
            window.localStorage.clear("cardNo");
          }, 1000);
      })
    }
  }
  componentDidMount(){
    this.getArea();
    // this.getList();
  }
  getArea = () => {
    let this_ = this;
    var postData = {};
    if(sessionStorage.getItem("subAdmin")) {
      postData["_url"] = "api/admin/area";
    } else {
      postData["_url"] = "api/dc/access/area";
    }
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = "roomId" + dataItem.roomId;
                arr3["id"] = dataItem.roomId;
                arr3["value"] = "roomId" + dataItem.roomId;
                arr3["dept"] = 3;
                let example = this_.state.example;
                example.push(arr3)
                this_.setState({
                  example
                })
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = "buildingId" + item.buildingId;
            arr2["id"] = item.buildingId;
            arr2["value"] = "buildingId" + item.buildingId;
            arr2["dept"] = 2;
            let example = this_.state.example;
            example.push(arr2)
            this_.setState({
              example
            })
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = "areaId" + index.areaId;
        arr1["id"] = index.areaId;
        arr1["value"] = "areaId" + index.areaId;
        arr1["dept"] = 1;
        let example = this_.state.example;
        example.push(arr1)
        this_.setState({
          example
        })
        return arr1;
      });
      // console.log(this_.state.example);
      obj.setState({
        treeData: ar
      })
    }, function(obj, state) {

    })
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '姓名',
      dataIndex: 'userName',
      must: true,
      show: true,
      width: '80px'
    }, {
      title: '学工号',
      dataIndex: 'cardNo',
      must: false,
      show: true,
      width: '100px',
    }, {
      title: '开门时间',
      dataIndex: 'passTime',
      must: false,
      show: true,
      width: '120px',
      render:(text, record) => {
        return (
          <span>{common.strToTime(record.passTime)}</span>
        )
      }
    }, {
      title: '开门方式',
      dataIndex: 'cardType',
      must: true,
      show: true,
      width : "160px",
      render: (text, record) => {
        return (
          <div>
          {record.cardType === 1?"远程":""}
          {record.cardType === 2?"实体卡" +((record.cardTypeSn in this.state.types)?("(" +  this.state.types[record.cardTypeSn] + ")"):''):""}
          {record.cardType === 3?"刷脸":""}
          {record.cardType === 8?"校园码":""}
          </div>
        )
      }
    }, {
      title: '实体卡号',
      dataIndex: 'cardNumber',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '部门',
      dataIndex: 'deptName',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '区域',
      dataIndex: 'doorName',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '刷脸图片',
      dataIndex: 'photoUrl',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {
        const content = (
          <div>
            <img className="img-big" src={record.photoUrl}/>
          </div>
        )
        return (
          <div>
            { record.photoUrl &&
              <Popover content={content}>
                <img className="img" src={record.photoUrl}/>
              </Popover>
            }
          </div>
        )
      }
    },{
      title: '是否通过',
      dataIndex: 'passResult',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {
        return (
          <span>{record.passResult >= 0?"通过":"未通过"}</span>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  getList = (pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    let roomIds = [];
    let buildings = [];
    let areaIds = [];
    this.state.example.map((item) => {
      if(this_.state.value.indexOf(item.value) > -1) {
        if(item.dept === 3) {
          roomIds.push(item.id);
        } else if(item.dept === 2){
          buildings.push(item.id);
        } else {
          areaIds.push(item.id);
        }
      }
    });
    var postData = {};
    postData["_url"] = "api/dc/open/record/search";
    postData["pageNum"] = pn;
    if(this.state.openTime !== "") {
      postData["GE"] = {passTime: this_.state.openTime[0]};
      postData["LE"] = {passTime: this_.state.openTime[1]};
    }
    if(this.state.cardType !== 0) {
      postData["cardType"] = this.state.cardType;
    }
    if(this.state.userName !== "") {
      postData["userName"] = this.state.userName;
    }
    if(this.state.cardNo !== "") {
      postData["cardNo"] = this.state.cardNo;
    }
    if(this.state.deptName !== "") {
      postData["deptName"] = this.state.deptName;
    }
    if(this.state.passResult !== 1) {
      postData["passResult"] = this.state.passResult;
    }
    if(roomIds.length > 0) {
      postData["roomIds"] = roomIds;
    }
    if(buildings.length > 0) {
      postData["buildingIds"] = buildings;
    }
    if(areaIds.length > 0) {
      postData["areaIds"] = areaIds;
    }
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  handleCancel = ()=> {
    this.setState({
      visible: false,
      downloadVisible: false
    });
  }
  onChange = (date, dateString) => {
    let this_ = this;
    if(dateString[0] !== "") {
      let arr = [];
      arr[0] = dateString[0] + ":00";
      arr[1] = dateString[1] + ":00";
      this_.setState({
        openTime: arr
      })
    } else {
      this_.setState({
        openTime: ''
      })
    }
  }
  handleChange = (value) => {
    this.setState({
      cardType: value
    })
  }
  handleChangeStatus = (value) => {
    this.setState({
      passResult: value
    })
  }
  setUserName = (e) => {
    this.setState({
      userName: e.target.value
    })
  }
  setCardNo = (e) => {
    this.setState({
      cardNo: e.target.value
    })
  }
  onChangeTree = (value) => {
    // console.log(value);
    this.setState({ value });

  }
  setDeptName = (e) => {
    this.setState({
      deptName: e.target.value
    })
  }
  downList = () => {
    if(this.state.table.dataSource.length === 0) {
      message.warning('请查询到结果后导出记录~');
      return;
    }
    var this_ = this;
    const table = this.state.table;
    let roomIds = [];
    let buildings = [];
    let areaIds = [];
    this.state.example.map((item) => {
      if(this_.state.value.indexOf(item.value) > -1) {
        if(item.dept === 3) {
          roomIds.push(item.id);
        } else if(item.dept === 2){
          buildings.push(item.id);
        } else {
          areaIds.push(item.id);
        }
      }
    });
    var postData = {};
    postData["_url"] = "api/dc/open/record/list/export";
    if(this.state.openTime !== "") {
      postData["GE"] = {passTime: this_.state.openTime[0]};
      postData["LE"] = {passTime: this_.state.openTime[1]};
    }
    if(this.state.cardType !== 0) {
      postData["cardType"] = this.state.cardType;
    }
    if(this.state.userName !== "") {
      postData["userName"] = this.state.userName;
    }
    if(this.state.cardNo !== "") {
      postData["cardNo"] = this.state.cardNo;
    }
    if(this.state.deptName !== "") {
      postData["deptName"] = this.state.deptName;
    }
    if(this.state.passResult !== 1) {
      postData["passResult"] = this.state.passResult;
    }
    if(roomIds.length > 0) {
      postData["roomIds"] = roomIds;
    }
    if(buildings.length > 0) {
      postData["buildingIds"] = buildings;
    }
    if(areaIds.length > 0) {
      postData["areaIds"] = areaIds;
    }
    common.request(postData, this, function(obj, data){
      obj.setState({
        downloadVisible: true
      })
    },function(obj, state){
    });
  }
  handleOk = () => {
    this.props.history.push('/record/export');
  }
  toRecordExport = () => {
    this.props.history.push('/record/export');
  }
  render(){
    const { table, passWDInfo } = this.state;
    const pswtitle = "请用支付宝扫码查看"+ this.state.orgName +"的密码";
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width:320
      },
    };
    return(
      <Card>
        <div>
          <div className="table-menu clearfix">
            <div className="pull-left">
              <Col span={8}>
                <label>姓&emsp;&emsp;名：</label>
                <Input style={{width:200}} placeholder="请输入姓名" value={ this.state.userName } onChange={ this.setUserName }/>
              </Col>
              <Col span={8}>
                <label>学 工 号：{" "}</label>
                <Input style={{width:200}} placeholder="请输入学工号" value={ this.state.cardNo } onChange={ this.setCardNo }/>
              </Col>
              <Col span={8}>
                <label>部门：</label>
                <Input style={{width:200}} placeholder="请输入部门" onChange={ this.setDeptName }/>
              </Col>
              <Col span={8} style={{marginTop: 14}}>
                <label>区&emsp;&emsp;域：</label>
                <TreeSelect {...tProps} style={{width:200}}/>
              </Col>
              <Col span={16} style={{marginTop: 15}}>
                <label>开门时间：</label>
                <RangePicker showTime={{ format: 'HH:mm' }} defaultValue={ defaultDate } format="YYYY-MM-DD HH:mm" onChange={ this.onChange }/>
              </Col>
              <Col span={8}>
                  <label>开门方式：</label>
                <Select style={{ width: 100,marginTop: 15 }} placeholder="全部" onChange={ this.handleChange }>
                  <Option value={0}>全部</Option>
                  <Option value={1}>远程</Option>
                  <Option value={2}>实体卡</Option>
                  <Option value={3}>刷脸</Option>
                  <Option value={8}>校园码</Option>
                </Select>
              </Col>
              <Col span={8}>
                  <label>通过状态：</label>
                <Select style={{ width: 100,marginTop: 15 }} placeholder="全部" onChange={ this.handleChangeStatus }>
                  <Option value={1}>全部</Option>
                  <Option value={0}>通过</Option>
                  <Option value={-1}>不通过</Option>
                </Select>
              </Col>
              <Col span={8} style={{marginTop: 15}}>
                <Button type="primary" onClick={ this.thisOk }>查询</Button>
              </Col>
              <Col span={24} style={{marginTop: 15}}>
                <Button type="primary" onClick={ this.toRecordExport }>导出记录</Button>
              </Col>
            </div>
            <div className="pull-right">
            { table.show && <MenuAction obj={ this } url="https://www.baidu.com" downlist={this.downList}/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            {/*<div className="table-total">共{ table.pagination.total }条数据</div>*/}
          </div>
          <Modal
            title="提示"
            visible={this.state.downloadVisible}
            onOk={this.handleOk}
            okText="前去下载"
            onCancel={this.handleCancel}
          >
            <p>数据导出已排队下载，请到导出记录中查看下载。</p>
          </Modal>
          <Modal
            title="查看密码"
            visible={this.state.visible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancel}
            footer={[
              <Button onClick={this.handleCancel}>关闭</Button>
            ]}
          >
            <div style={{textAlign: 'center'}}>
              <div id="pswtitle">{pswtitle}</div>
              {
                passWDInfo&&passWDInfo.status === "SUCCESS" ?
                <div id="pswDiv">
                  <div>账号：{passWDInfo.userName}</div>
                  <div>密码：{passWDInfo.passWord}</div>
                </div> :
                <img src={this.state.pwdUrl} width="175px"/>
              }
            </div>
          </Modal>
        </div>
      </Card>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/record/list.js